<template>
  <div>
    <gSwiper :arr="arr2" :maxH="'inherit'"></gSwiper>

    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="16">
        <div class="title">Bakery China Space Application</div>
        </Col>
        <Col span="8" class="f-tar">
        <Button shape="circle" style="margin-left:10px"
          @click="$router.push(`/ex-register/register-mobile`)">Chinese</Button>
        </Col>
      </Row>
      <registerForm ref="registerForm"></registerForm>

      <registerEntrance ref="registerEntrance"></registerEntrance>

      <div class="f-tac submit-btn">
        <Button type="primary" size="large" @click="handleSubmit" :loading="loading">Submit space application </Button>
      </div>

      <div class="tip-info">
        <p>Remarks：</p>
        <p>Please kindly note that this is an application form not a contract. There is a chance that you may not be
          allotted the size of stand which you desire.</p>
        <p>iBakeryChina online platform service fee: RMB 2,000 or USD 330/exhibitor/year (60% discount on original price
          RMB 5,000 or USD 825/year). It will be signed together with your booth contract. </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import registerForm from "./components/mobile-register-form.vue";
import registerEntrance from "./components/mobile-register-entrance.vue";
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import common from "@/utils/common";
import axios from "axios";
import { MD5 } from 'crypto-js';
export default {
  name: 'register',
  components: {
    registerForm,
    registerEntrance, gSwiper
  },
  props: {},
  data() {
    return {
      loading: false,
      // arr2: [{ id: 1, path: "https://bakery-oss.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202410/e8d24f1054da4185ae0d8fa3f46ab100.jpg" }],
      arr2: [{ id: 1, path: "https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202411/755acc9dd97f4d49a8b7f82102ec7e36.jpg" }],
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
    }),
    // 获取token
    async token(opt, res) {
      try {
        const params = new URLSearchParams();
        params.append('client_id', 'MYDev-G1a5arUpmsph159So8dEu6zZxBqJDs');
        params.append('client_secret', 'gykLH9zpRHGgMoGgFDvxqZnIBEkrTnWT4adt');
        params.append('grant_type', 'client_credentials');
        params.append('scope', 'open_api');

        const response = await axios.post('https://ecapi.expo2345.com/connect/token', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        });
        if (response.data.access_token) {
          this.tokens = response.data.access_token;
          this.myOtherCreate(opt, res)
        }
      } catch (error) {
        console.error('Error:', error);
      }

    },
    async handleSubmit() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerEntrance.validHandle();
      if (!res2.valid) return;


      let lists = [];
      if (res2.ApplyCompanyOrderNewDto) {
        lists.push({
          ...res2.ApplyCompanyOrderNewDto
        });
      }
      if (res2.ApplyCompanyOrderNewDto2) {
        lists.push({
          ...res2.ApplyCompanyOrderNewDto2
        });
      }
      let opt = {
        newCompany: { ...res.form, ...res2.common },
        lists: lists,
        reportType: 'en'
      };
      let exname = '';
      res2.exhibition.forEach((c, index) => {
        exname += c.nameEn;
        if (res2.exhibition.length !== index + 1) {
          exname += ','
        }
      });
      console.log('option', opt);
      // this.token(opt, res)

      let bool = await this.getApplyCompanyRoastCreate(opt);
      console.log('getApplyCompanyRoastCreate', bool);
      if (bool && bool.successed) {
        let query = 'company=' + encodeURI(res.form.companyNameEn) + '&exname=' + sessionStorage.setItem('exname', exname);
        this.$router.push(`/ex-register-en/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "error,try again";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }

    },
    // 提交到慕渊云
    async myOtherCreate(opt, res) {

      const xAdprvClientId = 'MYDev-G1a5arUpmsph159So8dEu6zZxBqJDs'
      const xAdprvClientSecret = '2Nt8sOQHkVjG/jOCA6pUEvhAm1ynag7/cWwx+y8ysXw='
      const noncestr = common.getRandomString(6)
      const timer = common.getUTCTimestampInSeconds()

      const sign = `x-adprv-client-id=${xAdprvClientId}\\\\x-adprv-client-secret=${xAdprvClientSecret}\\\\x-adprv-noncestr=${noncestr}\\\\x-adprv-timestamp=${timer}`
      const signMd5 = MD5(sign).toString();
      const address = {
        country: opt.newCompany.country,
        province: opt.newCompany.province,
        city: opt.newCompany.city,
        county: '',
        details: opt.newCompany.address,
        postcode: opt.newCompany.invoiceMalingCode
      }
      const contacts = [{
        "kind": 'Contact Person',
        "name": opt.newCompany.linkMan,
        "jobTitle": opt.newCompany.linkTitle,
        "phoneNumber": opt.newCompany.linkMob,
        "workEmail": opt.newCompany.linkEmail,
        "tel": {
          countryCode: '',
          areaCode: opt.newCompany.linkCode || '',
          code: opt.newCompany.linkTelephone || '',
          subcode: ''
        }
      }]
      const booths = []
      opt.lists.forEach((value, index) => {
        if (index == 0) {
          booths.push({
            "exhibitionId": "6b397ab4-e70a-24fd-637e-3a0ec8f94574",
            "kind": value.areaType == 'Raw Space' ? '特装' : '标展',
            "name": value.areaType,
            "num": value.showArea,
            "hall": value.exHall
          })
        }

      })
      const response = await axios
        .post(
          `https://ecapi.expo2345.com/api/v1/intention/CMEFOtherCreate`,
          {
            "name": opt.newCompany.companyName,
            "nameEn": opt.newCompany.companyNameEn,
            "shortNameEn": '',
            "address": address,
            "addressEn": "",
            "website": opt.newCompany.website,
            "fax": opt.newCompany.linkFax,
            "invoiceRemark": '',
            "attachmentLogoUrl": '',
            "contacts": contacts,
            "booths": booths,
            "specialFileds": {
              "joinProductType": opt.newCompany.productName,
              "advertPlan": opt.newCompany.planAd,
            },
            "projectId": "b2fa0915-254a-5a02-40ad-3a0cef45f376",
            "exhibitionId": "6b397ab4-e70a-24fd-637e-3a0ec8f94574"
          },
          {
            headers: {
              'x-exhibition-id': '6b397ab4-e70a-24fd-637e-3a0ec8f94574',
              'x-project-id': 'b2fa0915-254a-5a02-40ad-3a0cef45f376',
              'content-type': 'application/json',
              'x-adprv-noncestr': noncestr,
              'x-adprv-timestamp': timer,
              'x-adprv-sign': signMd5,
              'Authorization': 'Bearer ' + this.tokens
            }
          }
        )
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  created() {
    if (this.IsPC()) {
      this.$router.push(`/ex-register-en/register`);
    }
  },
  mounted() { }
}

</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;

  .top {
    padding: 15px;
  }

  .title {
    font-size: 15px;
    color: #b10042;
    font-weight: bold;
    line-height: 32px;
  }
}

.submit-btn {
  margin-top: 50px;
  text-align: center;

  button {
    padding: 0 46px;
    background-color: #b10042;
    font-size: 16px;
    border-color: #b10042;
    margin-bottom: 30px;
    height: 40px;
    border-radius: 20px;
    font-size: 15px;
    color: #fff;
  }
}

.tip-info {
  margin: 0 auto 48px;
  padding: 15px;
  white-space: nowrap;

  p {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
    white-space: normal;
  }
}
</style>
